const LAYER_LEGEND_BY_GRAPH = {
  grammar: [
    { layer: 0, label: 'L0 Foundation', shade: 'bg-gray-300 dark:bg-gray-600' },
    { layer: 1, label: 'L1 Agreement', shade: 'bg-gray-400 dark:bg-gray-550' },
    { layer: 2, label: 'L2 Structure', shade: 'bg-gray-500 dark:bg-gray-500' },
    { layer: 3, label: 'L3 Modifiers', shade: 'bg-gray-600 dark:bg-gray-450' },
    { layer: 4, label: 'L4 Rhetoric', shade: 'bg-gray-700 dark:bg-gray-400' },
  ],
  math: [
    { layer: 0, label: 'L0 Number Sense', shade: 'bg-gray-300 dark:bg-gray-600' },
    { layer: 1, label: 'L1 Algebra', shade: 'bg-gray-400 dark:bg-gray-550' },
    { layer: 2, label: 'L2 Linear & Data', shade: 'bg-gray-500 dark:bg-gray-500' },
    { layer: 3, label: 'L3 Nonlinear & Geometry', shade: 'bg-gray-600 dark:bg-gray-450' },
    { layer: 4, label: 'L4 Advanced Modeling', shade: 'bg-gray-700 dark:bg-gray-400' },
  ],
}

export default function ConceptLegend({ hasMasteryData, graph = 'grammar' }) {
  const layers = LAYER_LEGEND_BY_GRAPH[graph] || LAYER_LEGEND_BY_GRAPH.grammar

  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg p-3 space-y-3 text-xs">
      {/* Layer legend */}
      <div>
        <h4 className="font-medium text-gray-700 dark:text-gray-300 mb-1.5">Layers</h4>
        <div className="space-y-1">
          {layers.map(({ label, shade }) => (
            <div key={label} className="flex items-center gap-2">
              <div className={`w-4 h-2.5 rounded-sm ${shade}`} />
              <span className="text-gray-600 dark:text-gray-400">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Mastery legend */}
      {hasMasteryData && (
        <div>
          <h4 className="font-medium text-gray-700 dark:text-gray-300 mb-1.5">Mastery</h4>
          <div className="space-y-1">
            {[
              { label: '80%+ mastered', fill: 'bg-gray-900 dark:bg-gray-100' },
              { label: '50-79% developing', fill: 'bg-gray-600 dark:bg-gray-400' },
              { label: '25-49% weak', fill: 'bg-gray-400 dark:bg-gray-500' },
              { label: '<25% untested', fill: 'bg-gray-100 dark:bg-gray-800 border border-dashed border-gray-400 dark:border-gray-600' },
            ].map(({ label, fill }) => (
              <div key={label} className="flex items-center gap-2">
                <div className={`w-4 h-2.5 rounded-sm ${fill}`} />
                <span className="text-gray-600 dark:text-gray-400">{label}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Edge legend */}
      <div>
        <h4 className="font-medium text-gray-700 dark:text-gray-300 mb-1.5">Edges</h4>
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <div className="w-4 h-0 border-t border-gray-400 dark:border-gray-500" />
            <span className="text-gray-600 dark:text-gray-400">requires (child &rarr; parent)</span>
          </div>
        </div>
      </div>
    </div>
  )
}
